import * as _ from 'lodash';

export class LocalizedMessage {
  public values: any;
  public msg: string;

  constructor(msg: string, values: any = {}) {
    this.values = values;
    this.msg = msg;
  }
}

export function translateValidationObject(res) {
  return _.mapValues(res, (errorMessageIds, key) =>
    errorMessageIds.map(
      errorMessageId => (new LocalizedMessage(
        errorMessageId,
        {key}
      ))
    )
  );
}




// WEBPACK FOOTER //
// ./src/utilites/translate.ts